export const BOX_PADDING = { xs: 3, sm: 10, md: 15.5 }
